import * as React from "react";
import StarGreen from "@images/rating-star-filled-green.svg";
import StarHalfGreen from "@images/rating-star-half-green.svg";
import StarOrange from "@images/rating-star-filled-orange.svg";
import StarHalfOrange from "@images/rating-star-half-orange.svg";
import StarEmpty from "@images/rating-star-unfilled.svg";
import { Text } from "@uikit";

interface IProps {
  rating: number;
  mode?: "small" | "large";
  hideCount?: boolean;
  hideEmpty?: boolean;
  countSize?: number;
  color?: "orange" | "green";
  textColor?: "black" | "white";
  size: "tiny" | "small" | "medium" | "large" | "xlarge";
}

const StarRating = ({
  rating,
  mode = "large",
  hideCount = false,
  hideEmpty = false,
  countSize = 13,
  size = "small",
  color = "orange",
  textColor = "black",
}: IProps) => {
  const getStarSize = (
    size: "tiny" | "small" | "medium" | "large" | "xlarge"
  ) => {
    switch (size) {
      case "tiny":
        return "h-[10px] w-[10px]";
      case "small":
        return "h-[17px] w-[17px]";
      case "medium":
        return "h-5 w-5";
      case "large":
        return "h-7 w-7";
      case "xlarge":
        return "h-8 w-8";
    }
  };

  if (mode === "small") {
    return (
      <div className="flex gap-[5px] items-center">
        <div className={`${getStarSize(size)}`}>
          {rating === 0 ? (
            <StarEmpty className="w-full" />
          ) : (
            <>
              {color === "green" ? (
                <StarGreen className="w-full" />
              ) : (
                <StarOrange className="w-full" />
              )}
            </>
          )}
        </div>
        {!hideCount && rating > 0 && (
          <Text
            sizeTablet={countSize}
            sizeDesktop={countSize}
            size={countSize}
            color={textColor}
            weight="semibold"
          >
            {rating}
          </Text>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="flex gap-[2px] items-center">
        {[1, 2, 3, 4, 5].map((star, starIdx) => {
          const halfStarLower = star - 0.75;
          const halfStarUpper = star - 0.25;

          if (rating >= halfStarUpper) {
            return (
              <div key={starIdx} className={`${getStarSize(size)}`}>
                {color === "green" ? (
                  <StarGreen className="w-full" />
                ) : (
                  <StarOrange className="w-full" />
                )}
              </div>
            );
          }
          if (rating >= halfStarLower) {
            return (
              <div key={starIdx} className={`${getStarSize(size)}`}>
                {color === "green" ? (
                  <StarHalfGreen className="w-full" />
                ) : (
                  <StarHalfOrange className="w-full" />
                )}
              </div>
            );
          }
          if (!hideEmpty) {
            return (
              <div key={starIdx} className={`${getStarSize(size)}`}>
                <StarEmpty className="w-full" />
              </div>
            );
          }
        })}

        {!hideCount && (
          <Text
            sizeTablet={size === "tiny" ? 10 : 15}
            sizeDesktop={size === "tiny" ? 10 : 15}
            size={size === "tiny" ? 10 : 15}
            color={textColor}
            className="ml-[5px]"
            weight="semibold"
          >
            {rating}
          </Text>
        )}
      </div>
    </>
  );
};
export default StarRating;
